import { z } from "zod"

import stateCityDictionaryData from "./stateCityDictionaryData.json"

const stateCityDictionarySchema = z.record(
  z.string(),
  z.object({
    abbreviation: z.string(),
    cities: z.array(z.string()),
  }),
)

export const formatName = (name: string): string => {
  if (
    name.toLowerCase() === "coeur d'alene" ||
    name.toLowerCase() === "coeur d alene" ||
    name.toLowerCase() === "coeur d’alene"
  ) {
    return "Coeur d'Alene"
  }

  if (
    name.toLowerCase() === "winston salem" ||
    name.toLowerCase() === "winston-salem"
  ) {
    return "Winston-Salem"
  }

  return (
    name &&
    name
      .replace(/[-]/g, " ")
      .replace(/[%20]/g, " ")
      .split(" ")
      .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
      .join(" ")
      .replace("Of", "of")
  )
}

export const urlifyName = (name: string) => {
  return name?.toLowerCase().replace(/\s/g, "-")
}

// Resolve a URL slug back to the dataset's canonical spelling. Reformatting the
// slug loses meaningful internal capitalization (for example, McKinney).
export const findCanonicalCityName = (
  cities: readonly string[],
  citySlug: string,
): string | undefined => cities.find((city) => urlifyName(city) === citySlug)

export const urlifyComplexName = (text: string): string => {
  let urlifiedText = text.toLowerCase()
  urlifiedText = urlifiedText.replace(/[\s,;:!?()/.]+/g, "-")
  urlifiedText = urlifiedText.replace(/-+/g, "-")
  urlifiedText = urlifiedText.replace(/^-+|-+$/g, "")

  return urlifiedText
}

export const stateAbbreviationDictionary = {
  Alabama: "AL",
  Alaska: "AK",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  "District of Columbia": "DC",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
}

export interface IStateCityDictionary {
  [state: string]: {
    abbreviation: string
    cities: string[]
  }
}

const parsedDictionary = stateCityDictionarySchema.safeParse(
  stateCityDictionaryData,
)

if (parsedDictionary.success === false) {
  throw new Error("Invalid json data provided for stateCityDictionary")
}

export const stateCityDictionary = parsedDictionary.data

export default stateCityDictionary
